import Vue from 'vue';
import vmodal from 'vue-js-modal';
import ElementUI from 'element-ui';
import ElementLocale from 'element-ui/lib/locale/lang/zh-TW';
import ECharts from 'vue-echarts';
import Money from '@/components/ui/Money.vue';
import MoneyInput from '@/components/ui/MoneyInput.vue';
import ahTip from '@/components/ui/ahTip.vue';
import ahRichPopInfo from '@/components/ui/ahRichPopInfo.vue';
import * as math from 'mathjs';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import store from './store/store';
import router from './router';

// Vue-js-Modal (剩下繼續使用的視窗使用，待刪)

/* ----------------------------------------
    API 統一收發物件

    由 axios 包裝過濾器而成的 instance
    api        = 遇錯誤自動跳出錯誤訊息框
    api_silent = 不報任何錯誤，給其他人 catch
 ---------------------------------------- */
import api from './utils/api';
import api_silent from './utils/api_silent';

/* ----------------------------------------
    Filters 載入過濾器
 ---------------------------------------- */
import * as filters from './filters';

/* ----------------------------------------
    Mixin 載入共用方法 (helper)
 ---------------------------------------- */
import * as mixins from './mixins';

/* ------------- 以下為定義全域元件 ------------------ */

/* ----------------------------------------
    Element UI
 ---------------------------------------- */
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import './element-variables.scss';

// Animate.css
import 'animate.css/animate.min.css';

// CssShake
import 'csshake/dist/csshake.min.css';

/* ----------------------------------------
    echarts
 ---------------------------------------- */
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/polar';
import 'echarts/lib/component/legend';

/* ----------------------------------------
    通用元件
 ---------------------------------------- */
// 金額

// 提示

Vue.use(vmodal);

// 關閉建制提示 (console 畫面中)
Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$api_silent = api_silent;
Vue.prototype.$math = math;
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});
Vue.mixin({
    methods: {
        isPayed: mixins.isPayed,
        isAuth: mixins.isAuth,
        isAuthAll: mixins.isAuthAll,
        isAuthOne: mixins.isAuthOne,
        isMobile: mixins.isMobile,
        scrollToBottom: mixins.scrollToBottom,
        scrollToId: mixins.scrollToId,
        // 個資保護
        protectedInfo: mixins.protectedInfo,
        // protectedPaymentNumber: mixins.protectedPaymentNumber,
        // protectedPaymentEmail: mixins.protectedPaymentEmail,
    },
});
Vue.use(ElementUI, { locale: ElementLocale });
// import 'echarts-gl'
Vue.component('v-chart', ECharts);
Vue.component('Money', Money);
Vue.component('MoneyInput', MoneyInput);

Vue.component('ahTip', ahTip);
Vue.component('ahRichPopInfo', ahRichPopInfo);

/* ----------------------------------------
    日期 Helper
 ---------------------------------------- */
Date.prototype.yyyymmdd = function (seperator = '') {
    const mm = this.getMonth() + 1; // getMonth() is zero-based
    const dd = this.getDate();

    return [this.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join(seperator);
};

/* ----------------------------------------
    Sentry
 ---------------------------------------- */
Sentry.init({
    Vue,
    dsn: 'https://e5b1672a9fed45839c7835fc3109ef57@o4505560580947968.ingest.sentry.io/4505560848793600',
    environment: process.env.VUE_APP_ENV_NAME,
    integrations: [
        // new Sentry.BrowserTracing({
        //     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        //     shouldCreateSpanForRequest: (url) => !url.match(/\/ver\.json/),
        // }),
        // new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

/* ----------------------------------------
    掛載 Vue 與主要元件
 ---------------------------------------- */
new Vue({
    store,
    router,
    render: (h) => h(App),
}).$mount('#app');
